import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/** スキルマップ関連資料 */
export interface ISkillMapMaterialFile {
	fileIndex?: number; // ファイル番号
	fileName?: string; // ファイル名
	fileType?: string; // ファイルの種類
	materialName?: string; // 資料名
}

/** スキルマップ詳細情報 */
export interface ISkillMapDetail {
	applyFlg?: string; // 利用フラグ
	comment?: string; // 備考
	compulsoryID?: string; // 区分
	credit?: number; // 単位
	managementCode?: string; // 管理番号
	materialFileList?: ISkillMapMaterialFile[]; // スキルマップ関連資料
	outline?: string; // 概要
	purpose?: string; // 目的
	skillMapId?: string; // スキルマップID
	skillMapManager?: string; // スキルマップ管理者
	skillMapName?: string; // スキルマップ名
	subType?: string; // サブ種別
	target?: string; // 対象者
}

/** スキル詳細情報画面設定アクションクリエータ */
export const setSkillMapDetail = actionCreator<{
	skillMapInfo: ISkillMapDetail;
}>('SET_SKILL_MAP_DETAIL');



// WEBPACK FOOTER //
// ./src/actions/skillMapDetail.ts